module.exports = __webpack_public_path__ + "static/media/logo-green.d4a7f685.svg";